import Box from "@mui/material/Box";
import type { SxProps } from "@mui/material/styles";
import type { muiTheme } from "@polifonia/theme";
import { theme } from "@polifonia/theme";

import { Typography } from "@/components/Typography";

const styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "20px 24px",
    border: `1px solid ${theme.colors.staticFgLine}`,
    borderRadius: "12px",
    backgroundColor: theme.colors.white,
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flex: 1,
  },
} satisfies Record<string, SxProps<typeof muiTheme>>;

interface SummaryCardProps {
  title: React.ReactNode;
  children: React.ReactNode;
  /** A link to where the summary can be acted on. */
  action?: React.ReactNode;
  sx?: SxProps<typeof muiTheme>;
}

/** A titled card that summarizes one area and links to it. */
export const SummaryCard: React.FC<SummaryCardProps> = function SummaryCard({
  title,
  children,
  action,
  sx,
}) {
  return (
    <Box component="section" sx={{ ...styles.card, ...sx }}>
      <Typography variant="h3" fontWeight={700}>
        {title}
      </Typography>
      <Box sx={styles.body}>{children}</Box>
      {action ? <Box>{action}</Box> : null}
    </Box>
  );
};

/** Lays out summary cards in a responsive grid. */
export const SummaryCardGrid: React.FC<{ children: React.ReactNode }> =
  function SummaryCardGrid({ children }) {
    return (
      <Box
        sx={{
          display: "grid",
          gap: "16px",
          gridTemplateColumns:
            "repeat(auto-fill, minmax(min(280px, 100%), 1fr))",
        }}
      >
        {children}
      </Box>
    );
  };
